/* ==========================================================================
   pk-mini-cart-mobile-checkout.js - 2026-08-04

   Mobile mini cart, by request: drop the accelerated wallet buttons and leave
   the single "Checkout securely" button, with the accepted-card icons pinned
   underneath it.

   Hiding the wallet row is pure CSS and lives in
   snippets/pk-official-accelerated-checkout.liquid. This file exists only
   because the card icons cannot be moved with CSS: sections/pk-mini-cart.liquid
   renders .pkmc__payments inside .pkmc__secondary, which is in the SCROLLING
   .pkmc__body, while the target is the PINNED .pkmc__footer. They are different
   parents, so flex `order` cannot reach across them.

   FOOTER HEIGHT - READ THE SECTION COMMENT BEFORE CHANGING THIS
   sections/pk-mini-cart.liquid documents the footer as a deliberately bounded
   set, because on 2026-07-31 an unbounded footer grew to ~510px and left a
   375x812 phone with roughly 20px of scrollable cart. This move is safe only
   because it is a net REDUCTION: the wallet row it replaces is taller than the
   icon strip, and the strip is capped to a single row in CSS. Do not add
   anything else here.

   Desktop is untouched. The original position is recorded on first run and the
   node is put back if the viewport crosses back over 749px.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__PK_MINI_CART_MOBILE_CHECKOUT__) return;
  window.__PK_MINI_CART_MOBILE_CHECKOUT__ = true;

  var MOBILE = '(max-width: 749px)';
  var LADDER = [300, 900, 2000, 4000];

  var home = null;
  var homeNext = null;

  function payments() { return document.querySelector('#AarnaMiniCart .pkmc__payments'); }
  function footer() { return document.querySelector('#AarnaMiniCart .pkmc__footer'); }

  function sync() {
    var el = payments();
    var ft = footer();
    if (!el || !ft) return;

    /* Record where it started, once, before the first move. */
    if (!home && el.parentElement && el.parentElement !== ft) {
      home = el.parentElement;
      homeNext = el.nextElementSibling;
    }

    var wantsFooter = window.matchMedia && window.matchMedia(MOBILE).matches;

    if (wantsFooter) {
      if (el.parentElement !== ft) ft.appendChild(el);
      return;
    }

    if (home && el.parentElement !== home) {
      if (homeNext && homeNext.parentElement === home) home.insertBefore(el, homeNext);
      else home.appendChild(el);
    }
  }

  function boot() {
    sync();
    LADDER.forEach(function (ms) { window.setTimeout(sync, ms); });
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('orientationchange', sync, { passive: true });
    /* pk-mini-cart.js re-renders on every cart change; sync is idempotent, so
       this just self-heals if .pkmc__secondary is ever rebuilt. */
    document.addEventListener('peekora:cart:updated', sync);
    document.addEventListener('shopify:section:load', sync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
